import { bbAxios } from '@bb/session-manager';

import {
  QUESTIONNAIRES_ADD_SECTION_ENDPOINT,
  QUESTIONNAIRES_DEFAULT_ENDPOINT,
  QUESTIONNAIRES_ENDPOINT,
  QUESTIONNAIRES_LIST_ENDPOINT,
  QUESTIONNAIRES_MOVE_ENDPOINT,
} from '../endpoints.config';

export async function GetQuestionnaire(questionnaireId) {
  try {
    const { data } = await bbAxios.get(`${QUESTIONNAIRES_ENDPOINT}/${questionnaireId}`);
    return data;
  } catch (err) {
    console.error('Error! Failed to retrieve questionnaire with error:', err);
  }
}

export async function GetQuestionnaires() {
  try {
    const { data } = await bbAxios.get(`${QUESTIONNAIRES_LIST_ENDPOINT}`);
    return data;
  } catch (err) {
    console.error('Error! Failed to retrieve questionnaires list with error:', err);
  }
}

export async function GetQuestionnairesByContractType(contractType) {
  try {
    const { data } = await bbAxios.get(
      `${QUESTIONNAIRES_LIST_ENDPOINT}?contractType=${contractType}`
    );
    return data;
  } catch (err) {
    console.error('Error! Failed to retrieve questionnaires list with error:', err);
  }
}

export async function GetDefaultQuestionnaireByModelId(modelId) {
  try {
    const { data } = await bbAxios.get(
      `${QUESTIONNAIRES_DEFAULT_ENDPOINT}?modelId=${modelId}`
    );
    return data;
  } catch (err) {
    const msg = `Error! Failed to retrieve default questionnaire for model ${modelId} with error: ${err}`;
    console.error(msg);
  }
}

export async function GetQuestionnairesByModel(modelId) {
  try {
    const { data } = await bbAxios.get(`${QUESTIONNAIRES_ENDPOINT}?modelId=${modelId}`);
    return data;
  } catch (err) {
    const msg = `Error! Failed to retrieve questionnaires for model ${modelId} with error: ${err}}`;
    console.error(msg);
  }
}

export async function CreateQuestionnaire(data) {
  const { data: respData } = await bbAxios.post(`${QUESTIONNAIRES_ENDPOINT}`, data);
  return respData;
}

export async function MoveQuestion(id, direction, question, model) {
  const { data } = await bbAxios.post(QUESTIONNAIRES_MOVE_ENDPOINT(id), {
    direction,
    question,
    model,
  });
  return data;
}

export async function AddQuestionnaireSection(id, section, model) {
  const { data } = await bbAxios.post(QUESTIONNAIRES_ADD_SECTION_ENDPOINT(id), {
    section,
    model,
  });
  return data;
}

export async function DeleteQuestionnaire(params) {
  const { data } = await bbAxios.delete(`${QUESTIONNAIRES_ENDPOINT}?${params}`);
  return data;
}
